// ================================================
// MOMENTPRINTS – BELIEBT BADGE
// Zeigt "Beliebt" Pill-Badge mit Nase über der Größe
// Eingefügt von Mario | momentprints.de
// ================================================

(function () {

  /* ===== CSS EINBETTEN ===== */
  const style = document.createElement("style");
  style.textContent = `
    .tee-radio-label {
      overflow: visible !important;
    }

    .mp-size-badge {
      position: absolute !important;
      top: -18px !important;
      left: 65% !important;
      transform: translateX(-50%) !important;
      background: #0071E3 !important;
      color: #fff !important;
      padding: 4px 10px !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      border-radius: 999px !important;
      z-index: 1000 !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 4px !important;
      white-space: nowrap !important;
      pointer-events: none !important;
      line-height: 1 !important;
      overflow: visible !important;
    }

    /* Nase nach unten */
    .mp-size-badge::after {
      content: "" !important;
      position: absolute !important;
      bottom: -6px !important;
      left: 65% !important;
      transform: translateX(-50%) !important;
      width: 0 !important;
      height: 0 !important;
      border-left: 6px solid transparent !important;
      border-right: 6px solid transparent !important;
      border-top: 6px solid #0071E3 !important;
    }

    @media (max-width: 480px) {
      .mp-size-badge {
        top: -24px !important;
        padding: 3px 8px !important;
        font-size: 10px !important;
      }
    }
  `;
  document.head.appendChild(style);

  /* ===== KONFIG ===== */
  const BADGE_TEXT = "Beliebt";
  const BADGE_ICON = "";

  /* ===== HILFSFUNKTIONEN ===== */
  function simplify(str) {
    if (!str) return "";
    return str.toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function injectBadge(element) {
    if (!element || element.querySelector('.mp-size-badge')) return;
    const badge = document.createElement("span");
    badge.className = "mp-size-badge";
    badge.innerHTML = `<span>${BADGE_ICON}</span>${BADGE_TEXT}`;
    element.style.position = "relative";
    element.style.overflow = "visible";
    element.appendChild(badge);
    console.log("MP-Debug: Badge gesetzt für:", element.textContent.trim());
  }

  function applyBestsellerLogic() {
    const data = window.MP_BESTSELLER_DATA;
    if (!data || Object.keys(data).length === 0) return;

    const container = document.querySelector('.teeinblue') || document;
    const candidates = container.querySelectorAll('label, button, [role="button"], .variant-input-wrap div');

    candidates.forEach(el => {
      const visibleText = simplify(el.innerText);
      if (!visibleText) return;
      for (const key in data) {
        const targetText = simplify(key);
        if (visibleText === targetText || (visibleText.length > 1 && visibleText.includes(targetText))) {
          injectBadge(el);
        }
      }
    });
  }

  function init() {
    console.log("MP-Debug: Scanner gestartet mit Daten:", window.MP_BESTSELLER_DATA);
    applyBestsellerLogic();

    const observer = new MutationObserver(() => applyBestsellerLogic());
    observer.observe(document.body, { childList: true, subtree: true });

    setInterval(applyBestsellerLogic, 2000);
  }

  if (window.MP_BESTSELLER_DATA) {
    init();
  } else {
    window.addEventListener('mpDataReady', init);
    setTimeout(init, 2000);
  }

})();